import React from 'react';
import { Loading } from '/imports/ui/Loading';

interface LoadingFlexProps {
  caption?: string;
  className?: string;
}

export const LoadingFlex = (props: LoadingFlexProps) => (
  <div className={`loading-flex flex flex-1 flex-col justify-around bg-page ${props.className || ''}`}>
    <Loading caption={props.caption} />
  </div>
);
